import { FC } from 'react';
import { EStrapiRichText } from 'src/components/common/StrapiRichText/StrapiRichText.enum';
import { getHtmlTags } from 'src/functions/getHtmlTags';
import { EFlex } from 'src/styles/layouts/Flex/Flex.enum';
import NGText from 'src/styles/theme/components/NGText';
import { ESize } from 'src/styles/theme/utils/enums';
import { FlexEx, StyledListItems } from './List.styles';
import { IList } from './List.type';

const List: FC<IList> = ({ style, items, contentTagUpdated = false }) => {
	return (
		<FlexEx
			direction={EFlex.column}
			forwardedAs={style === EStrapiRichText.ordered ? 'ol' : 'ul'}
			margin={ESize.unset}
			paddingLeft={ESize.m}
			fullWidth
			paddingBottom={ESize['2xs']}
			paddingRight={ESize['2xs']}
		>
			{items?.length
				? items.map((listElement) => {
						return (
							<StyledListItems key={listElement}>
								<NGText size={ESize.m} className='richtext'>
									{getHtmlTags(listElement, contentTagUpdated)}
								</NGText>
							</StyledListItems>
						);
				  })
				: null}
		</FlexEx>
	);
};
export { List };
